/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { DatasetsResponse } from '@/client/models';
/**
 * DatasetsApi - axios parameter creator
 */
export const DatasetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get datasets information
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageDatasetsGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageDatasetsGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/datasets`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatasetsApi - functional programming interface
 */
export const DatasetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatasetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get datasets information
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageDatasetsGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageDatasetsGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetsApi.coverageCoverageDatasetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DatasetsApi - factory interface
 */
export const DatasetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatasetsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get datasets information
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageDatasetsGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetsResponse> {
            return localVarFp.coverageCoverageDatasetsGet(coverage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatasetsApi - interface
 */
export interface DatasetsApiInterface {
    /**
     * 
     * @summary Get datasets information
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageDatasetsGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetsResponse>;

}

/**
 * DatasetsApi - object-oriented interface
 */
export class DatasetsApi extends BaseAPI implements DatasetsApiInterface {
    /**
     * 
     * @summary Get datasets information
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageDatasetsGet(coverage: string, options?: RawAxiosRequestConfig) {
        return DatasetsApiFp(this.configuration).coverageCoverageDatasetsGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }
}

